
export const Features = {
  Warehouses: 'warehouses',
  Branches: 'branches',
  ManualJournal: 'manualJournal',
  Projects:'Projects',
  BankSyncing: 'BankSyncing',
  // Retenue à la source (RAS) marocaine — gate maître des écrans RAS.
  Ras: 'ras',
}